import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, API_BASE } from "../utils/api";
import "./AdminProducts.css";

export default function AdminProducts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  const fetchProducts = async () => {
    try {
      setLoading(true);
      setErr("");
      const res = await api.get("/api/products");
      setItems(res.data);
    } catch (e) {
      setErr(e.response?.data?.message || "Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const removeProduct = async (id) => {
    if (!window.confirm("Delete this product?")) return;
    await api.delete(`/api/products/${id}`);
    fetchProducts();
  };

  return (
    <div className="adminProductsWrap">
      <div className="adminProductsCard">
        {/* Header */}
        <div className="adminProductsTop">
          <div>
            <h2 className="adminProductsTitle">Products</h2>
            <p className="adminProductsSub">
              Edit, delete, and manage your shop items.
            </p>
          </div>

          <div className="adminProductsBtns">
            <button
              className="btnSecondary"
              onClick={() => navigate("/admin/dashboard")}
              type="button"
            >
              ← Dashboard
            </button>

            <button
              className="btnPrimary"
              onClick={() => navigate("/admin/add-product")}
              type="button"
            >
              + Add Product
            </button>
          </div>
        </div>

        {/* States */}
        {loading ? (
          <div className="stateBox">Loading products...</div>
        ) : err ? (
          <div className="stateBox error">{err}</div>
        ) : items.length === 0 ? (
          <div className="stateBox">No products found.</div>
        ) : (
          <div className="tableWrap">
            <table className="adminTable">
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Title</th>
                  <th>Price (AED)</th>
                  <th style={{ width: 220 }}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {items.map((p) => (
                  <tr key={p.id}>
                    <td>
                      {p.image_url ? (
                        <img
                          className="thumb"
                          src={`${API_BASE}${p.image_url}`}
                          alt={p.title}
                        />
                      ) : (
                        <div className="thumb placeholder">No Image</div>
                      )}
                    </td>

                    <td className="titleCell">{p.title}</td>

                    <td>
                      <span className="priceTag">
                        AED {Number(p.price_aed).toFixed(2)}
                      </span>
                    </td>

                    <td>
                      <div className="actions">
                        <button
                          className="actionBtn"
                          onClick={() => navigate(`/admin/edit-product/${p.id}`)}
                        >
                          Edit
                        </button>

                        <button
                          className="actionBtn danger"
                          onClick={() => removeProduct(p.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}